import {
  TOGGLE_QUICK_VIEW_TAB_1,
  TOGGLE_QUICK_VIEW_TAB_2,
  CLOSE_QUICK_VIEW,
} from 'stores/types/';

const initialSettings = {
  quickView: false,
  activeTab: 1
};

const dashboard = ( state = initialSettings, action ) => {
  switch( action.type ) {
    case TOGGLE_QUICK_VIEW_TAB_1:
      return {
        ...state,
        ...state.quickView ? { activeTab: 1 } : { quickView: true, activeTab: 1 }
      };
    case TOGGLE_QUICK_VIEW_TAB_2:
      return {
        ...state,
        ...state.quickView ? { activeTab: 2 } : { quickView: true, activeTab: 2 }
      };
    case CLOSE_QUICK_VIEW:
      return {
        ...state,
        quickView: false
      };
    default:
      return state;
  }
};

module.exports = dashboard;



// WEBPACK FOOTER //
// ./stores/reducers/operator/dashboard.js